import { isWithinDays } from '../../../../utils/utils'
import RenderHTML from '../../../ui-components/RenderHTML'
import { monthLookup } from '../../../../utils/utils'
import { GROUPED_STATIC_TEXT_ROLE } from '../../../ui-components/NameValueTableRow'

// Helper to safely fetch month short name
export const getMonthShort = (monthNum: number, fallback: string) => {
  const m = (monthLookup as any)?.[String(monthNum)]?.short
  return m || fallback
}

const PlanBanner = ({
  rebalanceSnapshotDate,
  planDurationInMonths = 2,
  rebalancePlanCount = 1
}: {
  rebalanceSnapshotDate?: number
  planDurationInMonths: number
  rebalancePlanCount: number
}) => {
  // Only show banner if within 30 days from rebalanceSnapshotDate
  if (!isWithinDays(rebalanceSnapshotDate, 30)) {
    return null
  }

  // Calculate firstPlanMonth from rebalanceSnapshotDate
  const firstPlanDate = rebalanceSnapshotDate ? new Date(rebalanceSnapshotDate) : new Date()
  const firstPlanMonth = firstPlanDate.getMonth() + 1 // getMonth() returns 0-11, so add 1

  // Calculate nextPlanMonth from firstPlanMonth + planDurationInMonths
  const nextPlanDate = new Date(firstPlanDate)
  nextPlanDate.setMonth(nextPlanDate.getMonth() + planDurationInMonths)
  const nextPlanMonth = nextPlanDate.getMonth() + 1

  const firstMonthName = getMonthShort(firstPlanMonth, '')
  const nextMonthName = getMonthShort(nextPlanMonth, '')
  const planText = `New plan for ${firstMonthName} - ${nextMonthName}`

  return (
    <div className='absolute top-[-40px] left-0 w-full h-full bg-[#B34A1F] z-[0] rounded-xl font-medium text-white'>
      {/* role=text + aria-label: expose plan period when children are aria-hidden (Reg_Power_Rebalancing_B02) */}
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        className='inline-flex gap-3 mt-[10px] ml-5 align-middle w-full h-fit'
        aria-label={planText}
      >
        <div aria-hidden='true'>
          <RenderHTML innerHTMLText={iconHTML} />
        </div>
        <div aria-hidden='true' className='text-sm text-white leading-[1] mt-[2px]'>
          <span className='pb-1 top-0'>{planText}</span>
        </div>
      </div>
    </div>
  )
}

export const iconHTML = `<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <g clip-path='url(#clip0_56985_31524)'>
                  <path
                    d='M5.92634 3.33887H2.30134C2.02665 3.33887 1.76321 3.44799 1.56898 3.64222C1.37474 3.83646 1.26562 4.09989 1.26562 4.37458V13.696C1.26562 13.9707 1.37474 14.2342 1.56898 14.4284C1.76321 14.6226 2.02665 14.7317 2.30134 14.7317H12.6585C13.2305 14.7317 13.6942 14.268 13.6942 13.696V8.51744'
                    stroke='white'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M1.26562 6.44629H7.47991'
                    stroke='white'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M10.7873 2.67038L11.3157 1.38729C11.3455 1.31485 11.4161 1.26758 11.4944 1.26758C11.5727 1.26758 11.6434 1.31485 11.6732 1.38729L12.2015 2.67038C12.4119 3.18116 12.8174 3.58677 13.3283 3.79709L14.6113 4.32543C14.6838 4.35525 14.731 4.42584 14.731 4.50419C14.731 4.58253 14.6838 4.65312 14.6113 4.68294L13.3283 5.21128C12.8174 5.4216 12.4119 5.82721 12.2015 6.33799L11.6732 7.62108C11.6434 7.69351 11.5727 7.74079 11.4944 7.74079C11.4161 7.74079 11.3455 7.69351 11.3157 7.62108L10.7873 6.33799C10.577 5.82721 10.1714 5.4216 9.66061 5.21128L8.37752 4.68294C8.30509 4.65312 8.25781 4.58253 8.25781 4.50419C8.25781 4.42584 8.30509 4.35525 8.37752 4.32543L9.66061 3.79709C10.1714 3.58677 10.577 3.18116 10.7873 2.67038Z'
                    stroke='white'
                    stroke-width='1.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_56985_31524'>
                    <rect width='16' height='16' fill='white' />
                  </clipPath>
                </defs>
              </svg>`

export default PlanBanner
